import './cards.css';
interface DomainIconProps {
  domain: string;
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
}

export function DomainIcon({ domain, className, style, alt = '' }: DomainIconProps) {
  const domainClass = `domain-icon domain-icon--${domain.toLowerCase()}`;
  return (
    <svg
      className={[domainClass, className].filter(Boolean).join(' ')}
      style={style}
      aria-label={alt || undefined}
      aria-hidden={!alt}
    >
      <use href={`#domain-${domain.toLowerCase()}`} />
    </svg>
  );
}
